import { discountCardCodes } from './discountCardCodes';

export const EUROSTAR = 'EUROSTAR';
export const EUROSTAR_ORGANIZATION = 'Eurostar';
export const OFFICE = 'Office';
export const THALYS_ADMIN_OFFICE = 'CSC_ADMIN';
export const THALYS_SUPER_USER_OFFICE = 'CSC_SUPER_USER';
export const THALYS_ADMIN_OR_SUPER_USER_OFFICES = [THALYS_ADMIN_OFFICE, THALYS_SUPER_USER_OFFICE];
export const THALYS_OTHER_OFFICES = ['CSC_PUBLIC', 'CSC_GROUP', 'CSC_STAFF'];
export const THALYS_OFFICES = [...THALYS_OTHER_OFFICES, ...THALYS_ADMIN_OR_SUPER_USER_OFFICES];
export const GROUP_EMAIL_QUOTE = 'GROUP_QUOTE';
export const OVERPAID_THRESHOLD_AMOUNT = -0.05;
export const GDS_AIR_ORGANIZATION = 'GDS_AIR';
export const TYPE_OF_USE = {
  BUSINESS: 'business',
  PERSONAL: 'personal'
};
export const DC_OFFICES = ['DC_GENERATE', 'DC_ENABLE', 'DC_DISABLE'];
export const LOUNGE_STAFF_OFFICES = ['LOUNGE_BEBMI', 'LOUNGE_GBSPX', 'LOUNGE_FRPNO'];
export const AUTO_ADD_DISCOUNT_CODE_LIST = [
  discountCardCodes.INTER,
  discountCardCodes.DUTYSNCF,
  discountCardCodes.FIP,
  discountCardCodes.INVIT,
  discountCardCodes.VIP_RP
];
export const SPX_STATION_USER = 'STN_GBSPX';
